import "./fonts/w3.css"
import "./fonts/style.css"
import { useState } from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MainPage } from './mainPage/mainPage';
import { AdminApp } from './Admin/AdminApp';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;